<template>
  <div>
    <div class="container-fluid my-2">
      <div class="card-body">
        <div class="panel-body">
          <MultiSelectionPicker
            :all-items="availables"
            :allow-item-list-editing="!readOnly"
            :column-count="1"
            item-type-name="Necesidad"
            maxlength="500"
            :modify-removes-item="true"
            :selected-items="selectedItems"
            @itemAdded="addNewNeed"
            @itemDeleted="deletedNeed"
            @itemModified="editNeed"
          />

          <div class="row mt-3">
            <div class="col-12">
              <Error
                is-alert-mode
                message="Puede seleccionar una(1) o más necesidades. Selección múltiple."
              />
            </div>
          </div>
          <CustomChipsGroup
            :disabled="readOnly"
            :no-wrap="true"
            object-text="name"
            :selected-items="selectedItems"
            title="Necesidades Seleccionadas"
            @itemMarkedForDeletion="removeSelection"
          />
        </div>
      </div>
    </div>
    <div class="actions">
      <ActionButton
        v-if="!readOnly"
        i="fas fa-save"
        variant="success m-2"
        @click="save"
      >
        Guardar
      </ActionButton>
    </div>
  </div>
</template>

<script>
import ActionButton from '@/components/common/ActionButton';
import MultiSelectionPicker from '@/components/common/MultiSelectionPicker';
import CustomChipsGroup from '@/components/common/CustomChipsGroup';
import Error from '@/components/common/Error';
import alertMixin from '@/mixins/alert.mixin.js';
import {
  getMeasureBankByUser as _getMeasureBankByUser,
  saveMeasureBankForUser as _saveMeasureBankForUser,
  deleteMeasureBankForUser as _deleteMeasureBankForUser,
} from '@/modules/referralManagement/api';
import MEASUREBANKTYPES from '@/utils/constants/measureBankTypes';

export default {
  name: 'NeedSelection',
  components: {
    ActionButton,
    MultiSelectionPicker,
    CustomChipsGroup,
    Error,
  },
  mixins: [alertMixin],
  props: {
    needs: {
      type: Array,
      default: new Array(),
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    disciplineTypeId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      availableNeeds: [],
      selectedItems: [],
      deletedNeeds: [],
      idCounter: 0,
    };
  },
  computed: {
    availables() {
      return this.availableNeeds.filter(
        (x) => !this.selectedItems.some((s) => s.name === x.name)
      );
    },
  },
  watch: {
    needs(val) {
      if (val.length > 0) {
        this.selectedItems = this.needs.map((s) => ({
          id: s.id,
          name: s.description,
        }));

        this.save();
      }
    },
  },
  async mounted() {
    // get saved needs for current user
    await this.getMeasureBankByUser();
  },
  methods: {
    removeSelection(item) {
      let editedItemIndex = this.selectedItems.findIndex(
        (e) => e.id === item.id
      );
      this.selectedItems.splice(editedItemIndex, 1);
    },
    editNeed(item, index) {
      if (item.id > 0) {
        item.isDirty = true;
      }
      this.availableNeeds.splice(index, 0, item);
    },
    async addNewNeed(itemText) {
      const { data: response } = await _saveMeasureBankForUser({
        measureTypeId: MEASUREBANKTYPES.Necesidades,
        disciplineTypeId: this.disciplineTypeId,
        description: itemText,
      });
      this.availableNeeds.push({
        id: response.id,
        name: response.name,
      });
    },
    async deletedNeed(item) {
      let alertResponse = await this.ShowCancelModal(
        'Atención',
        '¿Esta seguro que desea eliminar la necesidad "' + item.name + '"?',
        'Aceptar',
        'Cancelar'
      );

      if (alertResponse) {
        let removedItemIndex = this.availableNeeds.findIndex(
          (e) => e.id === item.id
        );
        this.availableNeeds.splice(removedItemIndex, 1);
        this.deletedNeeds.push(item);
        await _deleteMeasureBankForUser(item.id);
      }
    },
    async save() {
      this.$emit('save-needs', this.selectedItems);
    },
    async getMeasureBankByUser() {
      const { data: response } = await _getMeasureBankByUser(
        this.disciplineTypeId
      );
      if (response && response.length > 0) {
        this.availableNeeds = response.filter(
          (x) => x.measureTypeId === MEASUREBANKTYPES.Necesidades
        );
      }
    },
  },
};
</script>
<style scoped>
.actions {
  display: flex;
  justify-content: flex-end;
}
</style>
